import React, {useRef, useState, useEffect, useContext} from "react";
// import { getPhenomenaTypes } from '@futures-platform/connectors/drupal-api'
import { isEmpty } from "../../helpers/utils";
import { finalTranslations } from "../../localTranslation";
// import { phenomenonColor } from "../../helpers/phenomenonColor";
import { getPhenomenonUrl } from "../../helpers/contentCard";
import styles from "./RelatedPhenomena.module.css";
// import { ContentCardType } from "../ContentCardType";
import { ContentCardType} from "@futures-platform/ui";
import { getGroupInitials } from "../../helpers/groupInitials";
import GroupInitialsMark, { FpGroupMark, typeBubbleWrapStyle } from "../GroupInitialsMark";

import { votingApi } from '../../helpers/fetcher';
import {DataContext} from '../../store/GlobalState'
import { ACTIONS } from '../../store/Actions';
const RelatedPhenomena = ({ phenomenon, gid, rid, pid, lang , isTranslated , langForTransState}) => {
  const { state: {groupRadarIdGlobalState: groupRadarIdGlobalStateStore, getTheWholeCardHtmlElms, publicPhenomenaGroupsActived}, dispatch } = useContext(DataContext)
  // const [phenomenaTypesData, setPhenomenaTypesData] = useState(null);
  // useEffect(() => {
  //   const fetchPhenomenaTypes = async () => {
  //     const [ phenomenaTypes] = await Promise.all(
  //       [
  //         getPhenomenaTypes(gid || 0),

  //       ]
  //     )

  //     setPhenomenaTypesData(phenomenaTypes)

  //   }
  //   try {
  //     gid && rid && pid && fetchPhenomenaTypes()
  //   } catch (error) {

  //   }
  // }, [gid, rid, pid])

  // console.log('phenomenaTypesDataphenomenaTypesData', phenomenaTypesData)

  const titleRef = useRef()
    const nameRef = useRef()
    const titleRef2 = useRef()
    const nameRef2 = useRef()


    const [translations, settranslations] = useState(null)
    const [originalTitle, setoriginalTitle] = useState(null)
    const [originalText, setoriginalText] = useState(null)

  
    useEffect(() => {
      const fetcher = async () => {
        const [res1] = await Promise.all ([
            votingApi.translation("en", langForTransState, originalTitle),
            // votingApi.translation("en", langForTransState, originalText)
        ])
        const res2 = await Promise.all (
          !!originalText?.length && originalText?.map( child => {
            if(!!child) {
              return votingApi.translation("en", langForTransState, child?.innerHTML)
            }
            
          })
        )
        
        settranslations(() => {
          return {
            res1, 
            res2
          }
        })
      };
      !!isTranslated && !! originalTitle && !!originalText && fetcher();
      
    }, [ isTranslated, originalText, originalTitle, langForTransState])
  
    useEffect(() => {
      if (!!phenomenon["related-phenomena-data"]?.length) {
        if (true) {
          let namesOfPhencollection = []
          if (!!titleRef.current?.innerHTML && !titleRef2.current) {
            titleRef2.current = titleRef.current?.innerHTML
          }
          !!titleRef2.current && !originalTitle && setoriginalTitle(() => titleRef2.current)
          const phenList = Array.from(nameRef.current?.children ?? []) 
          !!phenList?.length && phenList?.map( child => {

            if(!!child) {
              const tempElm = child?.querySelector('h4') 

              namesOfPhencollection = [...namesOfPhencollection, tempElm]
            }
            
          })
          namesOfPhencollection = namesOfPhencollection?.filter((name) =>  !!name)
          
          if (!!nameRef.current && !nameRef2.current && !!namesOfPhencollection?.length) {
            nameRef2.current = namesOfPhencollection
          }
          !!nameRef2.current && !originalText && setoriginalText(() => nameRef2.current)
          // dispatch({
          //   type: ACTIONS.GETWHOLEHTMLCARD8,
          //   payload: true
          // })
        }
      }
    }, [dispatch, isTranslated, originalText, originalTitle, phenomenon])


  return !!phenomenon &&
    !isEmpty(phenomenon) &&
    phenomenon["related-phenomena-data"] &&
    phenomenon["related-phenomena-data"].length > 0 ? (
    <div className={styles.relatedPhenomenaWrapper}>
      {
        !isTranslated && (
          <h3 className={styles.h3Title} ref={titleRef}>
            {lang === "fi"
              ? finalTranslations?.relatedPhenomenaSection?.fi
              : finalTranslations?.relatedPhenomenaSection?.en}
          </h3>
        )
      }
      {
        !!isTranslated && (
          <h3 className={styles.h3Title} ref={titleRef} dangerouslySetInnerHTML={{__html: translations?.res1?.data}}>
          </h3>
        )
      }
      <table className="" ref={nameRef}>
        {!!phenomenon &&
          !!phenomenon["related-phenomena-data"]?.length &&
          phenomenon["related-phenomena-data"]?.map((phe, i) => {
            // phenomenaTypesData && phenomenaTypesData?.map(type => {
            //   if(type.id === phe.content.type) {
            //     phe['content-type-alias'] = type.alias;
            //     phe['content-type-title'] = type.title;
            //     phe['color'] = phe.content.type.includes('fp:doc-types') ? String(type.style.color): 'none'
            //   }
            // })
            // const {iconClassName, backgroundColor} = phenomenonColor(phe);
            const isFpGroup =
              Number(phe?.group) === 0 ||
              (!!phe?.groups?.length && Number(phe?.groups[0]) === 0);
            const groupInitials = getGroupInitials(phe?.group, publicPhenomenaGroupsActived)
            // phe['radarGroupId'] = Number(gid)
            return (
              <tr>
                <td>
                  <div
                    className={`content-card right ${styles.phenWrapper}`}
                    data-href={getPhenomenonUrl(rid, phe)}
                    style={{ cursor: "pointer", alignItems: 'center', display: 'flex' }}
                    data-position="right"
                  >
                    {/* <div className={`icon-issue ${iconClassName}`} style={{marginTop: '1px'}}></div> */}
                    <span style={typeBubbleWrapStyle(phe?.["content-type-alias"])}>
                      <ContentCardType 
                        isFpGroup={false} 
                        contentType={phe?.["content-type-alias"]}
                        customTypeStyleColor={phe?.["color"]}
                      />
                      {isFpGroup && <FpGroupMark typeAlias={phe?.["content-type-alias"]} />}
                      <GroupInitialsMark typeAlias={phe?.["content-type-alias"]} initials={groupInitials} />
                    </span>
                  </div>
                </td>
                <td>
                  <a
                    // href="#abc"
                    rel="noreferrer noopener"
                    target="_blank"
                    className={styles.phenLink}
                    style={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  key={phe?.id}
                >
                  {
                    !isTranslated && (
                      <h4
                        className={`content-card right ${styles.phenName} title`}
                        data-href={getPhenomenonUrl(rid, phe)}
                        style={{ cursor: "pointer" }}
                        data-position="right"
                      >
                        {phe?.content?.title}
                      </h4>
                    )
                  }
                  {
                    !!isTranslated && (
                      <h4
                        className={`content-card right ${styles.phenName}`}
                        data-href={getPhenomenonUrl(rid, phe)}
                        style={{ cursor: "pointer" }}
                        data-position="right"
                      >
                        {translations?.res2[i]?.data}
                      </h4>
                    )
                  }
                </a>
              </td>
            </tr>
            );
          })}
      </table>
    </div>
  ) : null;
};

export default RelatedPhenomena;
